import { cn } from "@/lib/utils";
import { DaysOption } from "@/types/bo/pickupDays";

type PickupDayButtonProps = {
  day: DaysOption;
  isAlreadySelected: boolean;
  handleChange: () => void;
};

export const PickupDayButton = ({ day, isAlreadySelected, handleChange }: PickupDayButtonProps) => (
  <button
    type="button"
    onClick={handleChange}
    className={cn(
      "flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 focus:outline-hidden",
      isAlreadySelected ? "bg-brand700 text-white" : "bg-white",
    )}
  >
    {day.label}
  </button>
);
